<div style="width: 600px; height: 700px;" data-cy="letters-delivery-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="letters-delivery-header-section">
      <div class="section-header-title" data-cy="letters-delivery-title-text">
        Letters Delivery Options
      </div>
      <div style="flex: 1;"></div>
    </div>
    <div class="section-content" style="flex: 1;" data-cy="letters-delivery-content-section">

    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="letters-delivery-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="letters-delivery-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="letters-delivery-ok-button">Ok</button>
    </div>
  </div>
</div>
